const alignmentOpts = [
    'left',
    'right',
    'center'
];
const isAlignment = (alignment)=>alignmentOpts.includes(alignment)
;
const isElement = (domNode)=>'attribs' in domNode
;
const isDomNode = (child)=>{
    return (child === null || child === void 0 ? void 0 : child.type) !== 'cdata' && (child === null || child === void 0 ? void 0 : child.type) !== 'root';
};
const isChildNodeElement = (child)=>isDomNode(child) && isElement(child)
;

export { isAlignment, isChildNodeElement, isDomNode, isElement };
//# sourceMappingURL=typeguards.js.map
